<div class="loadingBox" *ngIf="!loaded">
    <img  class="pulsateBG" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
   </div>
   <div *ngIf="loaded">
<div class="container-fluid mt-2">
    <div class="row">
  <div class="col-md-12">
<div class="row">
<div class="container-fluid">
    <div class="video-block section-padding">
       <div class="row">
            <div class="col-8 offset-2 offset-sm-3 col-sm-6 offset-md-3 col-md-6 offset-lg-4 col-lg-4">
                    <div class="channels-card">
                        <!-- <div class="channels-card-image">
                                <span class="unsubbutton"  *ngIf="channel.siteId > 0">
                                <img class="img-fluid" src="assets/img/videyo-holding.jpg" alt="">
                            </span>
                            <span class="unsubbutton"  *ngIf="channel.channelId > 0">
                                    <a routerLink="/channel/{{channel.id}}/explore">
                                        <img class="img-fluid" src={{channel.channelProfileImageUrl}} alt="">
                                    </a>
                                    </span>
                            <div class="channels-card-image-btn">
                                <a routerLink="/channel/{{channel.id}}/explore"></a>
                            </div>
                        </div> -->
                        <div class="channels-card-body">
                                <span  *ngIf="channel.siteId > 0">
                            <div class="channels-title">
                              <p><span i18n="@@So sad to see you go, just to confirm, you are wanting to unsubscribe from | So sad to see you go, just to confirm, you are wanting to unsubscribe from message">So sad to see you go, just to confirm, you are wanting to unsubscribe from</span> {{channel.siteName}}</p>
                            </div>
                            </span>
                            <span  *ngIf="channel.channelId > 0">
                                    <div class="channels-title">
                                        <p><span i18n="@@So sad to see you go, just to confirm, you are wanting to unsubscribe from | So sad to see you go, just to confirm, you are wanting to unsubscribe from message">So sad to see you go, just to confirm, you are wanting to unsubscribe from {{channel.channelName}}</span></p>
                                    </div>
                                    </span>
                            <span class="unsubbutton"  *ngIf="channel.siteId > 0">
                            <a (click)="unsubscribeSite()" href="javascript:;"   class="unsubbutton white-outline-button" data-toggle="modal" data-target="#unsubmodal" i18n="@@Yes Please, Unsubscribe Now | Yes Please, Unsubscribe Now Button">Yes Please, Unsubscribe Now</a>
                            </span>
                            <span class="unsubbutton"  *ngIf="channel.channelId > 0">
                            <a (click)="unsubscribeChannel()" href="javascript:;"  class="unsubbutton white-outline-button" data-toggle="modal" data-target="#unsubmodal" i18n="@@Yes Please, Unsubscribe Now | Yes Please, Unsubscribe Now Button">Yes Please, Unsubscribe Now</a>
                        </span>
                        <a  href="/"  class="unsubbutton white-outline-button" i18n="@@Oh No, Take me home! | Oh No, Take me home! Message">Oh no, Take me home!</a>
                        </div>
                    </div>
                </div>
    
       </div>
    </div>
 </div>
</div>
</div>
</div>
</div>
    <!-- add to favourites -->
    <div class="modal fade" id="unsubmodal" role="dialog">
        <div class="modal-dialog">
        
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-body">
                <br/><br/>
           <h4 class="text-center"><span i18n="@@You have unsubscribed from | You have unsubscribed from Message">You have unsubscribed from</span> {{channel.channelName}}{{channel.siteName}}</h4>
           <br/><br/>
            </div>
          </div>
          
        </div>
      </div>
      </div>
